import React from 'react'
import Wix from 'Wix';
import { IncognitoAppName, IncognitoContainer, IncognitoIconSpan, IncognitoTextContainer, IncognitoTextDescription, IncognitoTextHeader } from './style'
import bigHat from './img/bigHat.svg'
import hat from './img/hat.svg'
import textSliderIcon from './img/text_slider.png'


export default class IncognitoMode extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render () {
        const isMobile = Wix.Utils.getDeviceType() === 'mobile';
        const img = isMobile ? hat : bigHat
        return (
            <IncognitoContainer img={img} isMobile={isMobile} >
                <IncognitoTextContainer isMobile={isMobile} img={img}>
                    <IncognitoTextHeader isMobile={isMobile} >
                        WARNING
                    </IncognitoTextHeader>
                    <IncognitoTextDescription isMobile={isMobile}>
                        <img src={textSliderIcon}/><span>Impressive Text Slider</span> is using session storage in order to communicate with the settings panel appropriate. The incognito mode blocks the session storage due to the browser's privacy policy. Please disable the incognito mode and third-party cookies in order to make the Impressive Text Slider work as it expected.
                    </IncognitoTextDescription>
                </IncognitoTextContainer>
                <IncognitoAppName isMobile={isMobile}>
                    <img src={textSliderIcon}/>
                    <span>Impressive Text Slider</span>
                </IncognitoAppName>
            </IncognitoContainer>
        )
    }
}